import { render, staticRenderFns } from "./BarStatistics.vue?vue&type=template&id=4896f43f"
import script from "./BarStatistics.vue?vue&type=script&lang=ts"
export * from "./BarStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports